import React, { useEffect } from 'react';
import { Col, Form, Input, Row, Switch, Typography } from 'antd';
import type { FormInstance } from 'antd';
import type { CustomerSegmentDetail, CustomerSegmentFormValues } from '../types';

const { TextArea } = Input;
const { Title } = Typography;

export interface CustomerSegmentFormProps {
  form: FormInstance<CustomerSegmentFormFieldValues>;
  initialValues?: CustomerSegmentDetail | null;
  onFinish: (values: CustomerSegmentFormValues) => void;
}

export interface CustomerSegmentFormFieldValues extends CustomerSegmentFormValues {}

function detailToFormValues(d: CustomerSegmentDetail): CustomerSegmentFormFieldValues {
  return {
    title: d.title,
    description: d.description ?? undefined,
    isActive: d.isActive,
  };
}

const CustomerSegmentForm: React.FC<CustomerSegmentFormProps> = ({
  form,
  initialValues,
  onFinish,
}) => {
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(detailToFormValues(initialValues));
    } else {
      form.resetFields();
      form.setFieldsValue({ isActive: true });
    }
  }, [initialValues, form]);

  return (
    <Form<CustomerSegmentFormFieldValues>
      form={form}
      layout="vertical"
      onFinish={onFinish}
    >
      <div className="cp-form-section">
        <Title level={5} style={{ marginTop: 0 }}>
          Details
        </Title>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="title"
              label="Name"
              rules={[{ required: true, message: 'Name is required' }]}
            >
              <Input placeholder="e.g. Enterprise" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="isActive" label="Active" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </div>

      <div className="cp-form-section">
        <Title level={5} style={{ marginTop: 0 }}>
          Description
        </Title>
        <Form.Item name="description">
          <TextArea rows={4} placeholder="Optional notes for your team" />
        </Form.Item>
      </div>
    </Form>
  );
};

export default CustomerSegmentForm;
